import * as React from 'react';
import { useState } from "react";
import { 
    Button, 
    Typography, 
    Box,
} from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import CachedIcon from '@mui/icons-material/Cached';
import { ReindexModal, CleanCacheModal } from 'src/resources/configuration/commands';

export function ConfigurationToolbar() {
    const [reindexModal, setReindexModal] = useState(false);
    const [cleanCacheModal, setCleanCacheModal] = useState(false);

    const setReindexModalHandler = (value: boolean) => {
        setReindexModal(value);
    }
    
    const setCleanCacheModalHandler = (value: boolean) => {
        setCleanCacheModal(value);
    }

    return (
        <>
        <Box marginY="10px" display="flex" gap="5px" alignSelf="end">
            <Button onClick={() => setReindexModalHandler(true)} variant="outlined" size="small">
                <ListIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Reindex</Typography>
            </Button>
            <Button onClick={() => setCleanCacheModalHandler(true)} variant="outlined" size="small">
                <CachedIcon sx={{ fontSize: "18px"}} />
                <Typography component="span" sx={{lineHeight: "1.75", fontSize: "14px", marginLeft: "8px", fontWeight: 600}}>Clean Cache</Typography>
            </Button>
        </Box>

        {reindexModal &&
        <ReindexModal
            open={reindexModal}
            setOpen={setReindexModalHandler}
        />
        }

        {cleanCacheModal &&
        <CleanCacheModal
            open={cleanCacheModal}
            setOpen={setCleanCacheModalHandler}
        />
        }
        </>
    );
}